import { render } from "./Comics.vue?vue&type=template&id=276aea8a"
import script from "./Comics.vue?vue&type=script&lang=js"
export * from "./Comics.vue?vue&type=script&lang=js"

import exportComponent from "/home/federico/Progetti/PizzaReader/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__